import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'

export const AlertAddTrialCredits = observer(() => {
  const { remindersStore } = useEntitiesContext()
  const { trialCreditsStore } = remindersStore

  if (!trialCreditsStore.show) return null
  if (trialCreditsStore.isOrganizationOwner) {
    return (
      <Alert
        item={{
          type: 'warning',
          title: 'Your organization is out of trial credits',
          desc: 'Upgrade now to continue sending messages',
        }}
        actions={[
          {
            type: 'primary',
            variant: 'button',
            text: 'Upgrade now',
            onClick: () =>
              uiStore.changeRouteViaVue({
                path: `/${BillingPath.upgrade}`,
              }),
          },
        ]}
      />
    )
  }

  return (
    <Alert
      item={{
        type: 'warning',
        title: 'Your organization is out of trial credits',
        desc: 'Ask your organization owner to upgrade to continue sending messages',
      }}
    />
  )
})
